'use client';

import React, { useState, useEffect } from 'react';
import HeroSection from './HeroSection';
import TrustSignals from './TrustSignals';
import FleetSizeSelector from './FleetSizeSelector';
import VideoTestimonials from './VideoTestimonials';
import WhyChooseUs from './WhyChooseUs';
import ProcessOverview from './ProcessOverview';
import FinalCTA from './FinalCTA';

const HomepageInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleGetStarted = () => {
    if (!isHydrated) return;
    
    const fleetSelectorSection = document.getElementById('fleet-selector');
    if (fleetSelectorSection) {
      fleetSelectorSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="min-h-screen">
      <HeroSection onGetStarted={handleGetStarted} />
      <TrustSignals />
      <div id="fleet-selector">
        <FleetSizeSelector />
      </div>
      <WhyChooseUs />
      <ProcessOverview />
      <VideoTestimonials />
      <FinalCTA />
    </div>
  );
};

export default HomepageInteractive;